<template>
  <div class="main">
    <Header :title="title" />
    <div class="container my-con">
      <div class="card">
        <h2 class="title">
          {{ title }}
        </h2>
        <base-info :base-info="reportInfo" />
        <item-detail title-text="妇科检查结果">
          <template>
            <div class="content">
              <p>
                <span class="label">外阴：</span>
                <span class="text">{{ this.cervix.waiyin === '异常' ? this.vulva.join('；') : this.cervix.waiyin }}</span>
              </p>
              <p>
                <span class="label">阴道：</span>
                <span class="text">{{ this.cervix.yindao === '异常' ? this.vaginal.join('；') : this.cervix.yindao }}</span>
              </p>
              <p>
                <span class="label">分泌物：</span>
                <span class="text">{{ this.cervix.fenmiwu === '异常' ? this.secretions.join('；') : this.cervix.fenmiwu }}</span>
              </p>
              <p>
                <span class="label">子宫颈：</span>
                <span class="text">{{ this.cervix.zigongjing === '异常' ? this.cervical.join('；') : this.cervix.zigongjing }}</span>
              </p>
              <p>
                <span class="label">子宫：</span>
                <span class="text">{{ this.cervix.zigong === '异常' ? this.uterus.join('；') : this.cervix.zigong }}</span>
              </p>
              <p>
                <span class="label">盆腔：</span>
                <span class="text">{{ this.cervix.penqiang === '异常' ? this.pelvic.join('；') : this.cervix.penqiang }}</span>
              </p>
            </div>
          </template>
        </item-detail>
        <item-detail title-text="分泌物检查结果">
          <template>
            <div class="content">
              <p
                v-for="item in this.secretionsResult"
                :key="item.label"
              >
                <span class="label">{{ item.label }}</span>
                <span class="text">{{ item.value }}</span>
              </p>
            </div>
          </template>
        </item-detail>
        <item-detail title-text="临床诊断">
          <template>
            <div class="content">
              <p>{{ this.diagnosisResult.join('，') }}</p>
            </div>
          </template>
        </item-detail>
        <item-detail title-text="">
          <template>
            <div class="doctor-message">
              <div>检查医院：{{ reportInfo.cervixHospitalName }}</div>
              <div>检查医师：{{ reportInfo.cervixDoctorName }}</div>
            </div>
          </template>
        </item-detail>
      </div>
      <div class="card">
        <van-cell
          title="用户资料"
          is-link
          @click="viewUserData"
        />
      </div>
    </div>
    <van-overlay :show="loading">
      <div class="loading-box">
        <van-loading>加载中...</van-loading>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import Header from '@/components/header'
import baseInfo from '@/components/baseInfo'
import itemDetail from '@/components/ItemDetail'
import { Cell, Loading, Overlay, Swipe, SwipeItem } from 'vant'
import { deepJsonParse } from '@/utils/handleJSON'

export default {
  components: {
    Header,
    baseInfo,
    itemDetail,
    [Cell.name]: Cell,
    [Loading.name]: Loading,
    [Overlay.name]: Overlay,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  data () {
    return {
      title: '妇科检查报告',
      reportInfo: {
        name: '',
        sex: '',
        age: '',
        date: '',
        id: ''
      },
      cervix: {},
      vulva: [], // 外阴
      vaginal: [], // 阴道
      secretions: [], // 分泌物
      cervical: [], // 子宫颈
      uterus: [], // 子宫检查结果
      pelvic: [], // 盆腔检查结果
      secretionsResult: [], // 分泌物检查结果
      diagnosisResult: [], // 诊断结果,
      loading: false
    }
  },
  created () {
    this.getData()
  },
  methods: {
    async getData () {
      this.loading = true
      // 获取报告详情
      const { data } = await this.$api.personal.getReportDetail({
        id: this.$route.params.id
      })
      this.loading = false
      const { cervixDate, registerDate, cervix, ...detail } = data
      this.cervix = deepJsonParse(cervix) || {}
      // 外阴
      if (this.cervix.waiyin === '异常') {
        this.vulva = this.cervix.waiyinmore.map(item => {
          if (item === '其他') {
            return this.cervix.waiyin_other
          } else {
            return item
          }
        })
      }
      // 阴道
      if (this.cervix.yindao === '异常') {
        this.vaginal = this.cervix.yindaomore.map(item => {
          if (item === '其他') {
            return this.cervix.yindao_other
          } else {
            return item
          }
        })
      }
      // 分泌物
      if (this.cervix.fenmiwu === '异常') {
        this.secretions = this.cervix.fenmiwumore.map(item => {
          if (item === '其他') {
            return this.cervix.fenmiwu_other
          } else {
            return item
          }
        })
      }
      // 子宫颈
      if (this.cervix.zigongjing === '异常') {
        this.cervical = this.cervix.zigongjingmore.map(item => {
          if (item === '其他') {
            return this.cervix.zigongjing_other
          } else {
            return item
          }
        })
      }
      // 子宫检查结果的数据处理
      if (this.cervix.zigong === '异常') {
        this.uterus = this.cervix.zigongmore.map(item => {
          if (item === '大小') {
            if (this.cervix.zigongdaxiao === '孕周') {
              return `大小(如孕周 ${this.cervix.yunzhou}周)`
            } else if (this.cervix.zigongdaxiao === '正常') {
              return '大小(正常)'
            }
          } else if (item === '肿物') {
            if (this.cervix.zigongzhongwudaxiao === '不可测量') {
              return `肿物(不可测量，${this.cervix.zigongzhongwuxingzhuang}，${this.cervix.zigongzhongwuweizhi})`
            } else if (this.cervix.zigongzhongwudaxiao === '可测量') {
              return `肿物(${this.cervix.zigongzhongwudaxiaonum1}mm * ${this.cervix.zigongzhongwudaxiaonum1}mm，${this.cervix.zigongzhongwuxingzhuang}，${this.cervix.zigongzhongwuweizhi})`
            }
          } else if (item === '切除') {
            return this.cervix.zigongqiechu
          } else if (item === '上环') {
            return this.cervix.shanghuan
          } else if (item === '其他') {
            return this.cervix.zigong_other
          } else {
            return item
          }
        })
      }
      // 盆腔检查结果
      if (this.cervix.penqiang === '异常') {
        this.pelvic = this.cervix.penqiangmore.map(item => {
          if (item === '压痛') {
            return `压痛: ${this.cervix.penqiangyatong}`
          } else if (item === '肿物') {
            const leftSize = `${this.cervix.penqiangzhongwudaxiao_l ? (this.cervix.penqiangzhongwudaxiao_l === '可测量' ? `${this.cervix.penqiangzhongwudaxiaonum1_l}mm * ${this.cervix.penqiangzhongwudaxiaonum2_l}mm` : '不可测量') : ''}`
            const rightSize = `${this.cervix.penqiangzhongwudaxiao_r ? (this.cervix.penqiangzhongwudaxiao_r === '可测量' ? `${this.cervix.penqiangzhongwudaxiaonum1_r}mm * ${this.cervix.penqiangzhongwudaxiaonum2_r}mm` : '不可测量') : ''}`
            if (this.cervix.penqiangzhongwu === '双侧') {
              return `肿物: 大小(左侧-${leftSize}; 右侧-${rightSize}), 性状(${this.cervix.penqiangzhongwuxingzhuang})`
            } else if (this.cervix.penqiangzhongwu === '左侧') {
              return `肿物: 大小(左侧-${leftSize}), 性状(${this.cervix.penqiangzhongwuxingzhuang})`
            } else if (this.cervix.penqiangzhongwu === '右侧') {
              return `肿物: 大小(右侧-${rightSize}), 性状(${this.cervix.penqiangzhongwuxingzhuang})`
            }
          } else if (item === '其他') {
            return this.cervix.penqiang_other
          } else if (item === '积液') {
            return item
          }
        })
      }
      // 分泌物检查结果
      this.secretionsResult = this.cervix.fenmiwuinspect ? this.cervix.fenmiwuinspect.map(item => {
        // item 指的是分泌物检查的项目
        if (item === '清洁度') {
          return {
            label: item,
            value: this.cervix.fenmiwuqingjiedu
          }
        } else if (item === '脓细胞') {
          return {
            label: item,
            value: this.cervix.nongxibao
          }
        } else if (item === '白细胞') {
          return {
            label: item,
            value: this.cervix.baixibao
          }
        } else if (item === '上皮细胞') {
          return {
            label: item,
            value: this.cervix.shangpixibao
          }
        } else if (item === '红细胞') {
          return {
            label: item,
            value: this.cervix.hongxibao
          }
        } else if (item === '其他') {
          return {
            label: item,
            value: this.cervix.fenmiwuinspect_other
          }
        } else {
          return {
            label: item,
            value: '查见'
          }
        }
      }) : []
      // 诊断结果
      if (this.cervix.linchuangzhenduan === '未见异常') {
        this.diagnosisResult = ['未见异常']
      } else {
        this.diagnosisResult = this.cervix.zhenduanmore ? this.cervix.zhenduanmore.map(item => {
          return item === '其他' ? this.cervix.zhenduan_other : item
        }) : []
      }
      detail.date = cervixDate || registerDate
      this.reportInfo = detail
    },
    viewUserData () {
      this.$router.push(`/jcbg/${this.reportInfo.id}`)
    }
  }
}
</script>

<style scoped lang="less">
.container {
  font-size: 0.32rem;
  background-color: #f7f7f7;
  .card {
    background-color: white;
    margin-bottom: .2rem;
  }
  h2 {
    padding: 15px 0;
    font-size: 0.44rem;
    font-weight: 400;
    text-align: center;
  }
  .content {
    font-size: 0.28rem;
    p {
      margin-bottom: 20px;
    }
    .label {
      display: inline-block;
      color: #aeaeae;
      width: 2rem;
      vertical-align: top;
    }
    .text {
      display: inline-block;
      width: calc(90vw - 2rem);
    }
  }
  .doctor-message {
    font-size: .28rem;
    display: flex;
    justify-content: space-between;
  }
}
.loading-box {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-loading__text{
    color: #ffffff;
  }
  .van-loading {
    color: #ffffff;
  }
}
</style>
